import {FC, useEffect, useState} from 'react';
import {
    ArtzLegalsWrapper,
    LegalsBtn,
    LegalsContent,
    LegalsTitle,
    LegalsCloseWrapper,
    ApproveBtn,
    LegalsContentShadowWrapper, LegalsShadow
} from './styled';
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';
import {ArtzLegalsText, ArtzLegalsTextTablet} from './const/ArtzLegalsText';
import { useTranslation } from 'react-i18next';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";

export const ArtzLegalsModal: FC<{
    onClick: (projectId: string) => void,
    onClose: () => void,
    projectId: string,
}> = ({
    onClick,
    onClose,
    projectId
}) => {
    const { t, i18n } = useTranslation();
    const is744BP = useBreakpoint(LayoutConst.screen.s);
    const is992BP = useBreakpoint(LayoutConst.screen.m);
    const [height, setHeight] = useState(document.body.offsetHeight);

    const handleSend = () => onClick && projectId && onClick(projectId);

    useEffect(() => {
        const handler = () => setHeight(document.body.offsetHeight);
        window.addEventListener('resize', handler);

        return () => window.removeEventListener('resize', handler);
    }, [])

    return (
        <ArtzLegalsWrapper height={height}>
            <LegalsCloseWrapper><IconCloseMob onClick={onClose}/></LegalsCloseWrapper>
            <LegalsTitle>{t('legals.artz_legals.title')}</LegalsTitle>
            <LegalsContentShadowWrapper>
                <LegalsContent>
                    {(is992BP && !is744BP)
                        ? <ArtzLegalsTextTablet lang={i18n.language} />
                        : <ArtzLegalsText lang={i18n.language} />}
                </LegalsContent>
                <LegalsShadow/>
            </LegalsContentShadowWrapper>
            <LegalsBtn>
                <ApproveBtn onClick={handleSend}>{t('legals.artz_legals.btn_text')}</ApproveBtn>
            </LegalsBtn>
        </ArtzLegalsWrapper>
    )
}import {FC, useEffect, useState} from 'react';
import {
    ArtzLegalsWrapper,
    LegalsBtn,
    LegalsContent,
    LegalsTitle,
    LegalsCloseWrapper,
    ApproveBtn,
    LegalsContentShadowWrapper, LegalsShadow
} from './styled';
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal';
import {ArtzLegalsText, ArtzLegalsTextTablet} from './const/ArtzLegalsText';
import { useTranslation } from 'react-i18next';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";

export const ArtzLegalsModal: FC<{
    onClick: (projectId: string) => void,
    onClose: () => void,
    projectId: string,
}> = ({
    onClick,
    onClose,
    projectId
}) => {
    const { t, i18n } = useTranslation();
    const is744BP = useBreakpoint(LayoutConst.screen.s);
    const is992BP = useBreakpoint(LayoutConst.screen.m);
    const [height, setHeight] = useState(document.body.offsetHeight);

    const handleSend = () => onClick && projectId && onClick(projectId);

    useEffect(() => {
        const handler = () => setHeight(document.body.offsetHeight);
        window.addEventListener('resize', handler);

        return () => window.removeEventListener('resize', handler);
    }, [])

    return (
        <ArtzLegalsWrapper height={height}>
            <LegalsCloseWrapper><IconCloseMob onClick={onClose}/></LegalsCloseWrapper>
            <LegalsTitle>{t('legals.artz_legals.title')}</LegalsTitle>
            <LegalsContentShadowWrapper>
                <LegalsContent>
                    {(is992BP && !is744BP)
                        ? <ArtzLegalsTextTablet lang={i18n.language} />
                        : <ArtzLegalsText lang={i18n.language} />}
                </LegalsContent>
                <LegalsShadow/>
            </LegalsContentShadowWrapper>
            <LegalsBtn>
                <ApproveBtn onClick={handleSend}>{t('legals.artz_legals.btn_text')}</ApproveBtn>
            </LegalsBtn>
        </ArtzLegalsWrapper>
    )
}